<script lang="ts">
  import { onMount, onDestroy } from "svelte"
  import type { Chart as ChartInstance } from "chart.js"

  type RiskEventData = {
    labels: string[]
    pii_values: number[]
    secret_values: number[]
  }

  let { data = { labels: [], pii_values: [], secret_values: [] } }: { data: RiskEventData } = $props()

  let canvas: HTMLCanvasElement | undefined = $state()
  let chart: ChartInstance | null = null

  const hasData = $derived(data.pii_values.some((value) => value > 0) || data.secret_values.some((value) => value > 0))

  onMount(async () => {
    if (!canvas) return

    const { Chart, registerables } = await import("chart.js")
    Chart.register(...registerables)

    chart = new Chart(canvas, {
      type: "line",
      data: {
        labels: data.labels,
        datasets: [
          {
            label: "PII 탐지",
            data: data.pii_values,
            borderColor: "#3E6AE1",
            backgroundColor: "#3E6AE1",
            pointRadius: 2,
            pointHoverRadius: 4,
            tension: 0.3
          },
          {
            label: "Secret 탐지",
            data: data.secret_values,
            borderColor: "#5C5E62",
            backgroundColor: "#5C5E62",
            pointRadius: 2,
            pointHoverRadius: 4,
            tension: 0.3
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          intersect: false,
          mode: "index"
        },
        plugins: {
          legend: {
            display: true,
            labels: {
              color: "#5C5E62",
              boxWidth: 10,
              boxHeight: 10,
              font: { size: 12 }
            }
          }
        },
        scales: {
          x: {
            ticks: { color: "#5C5E62", font: { size: 11 }, maxTicksLimit: 8 },
            grid: { display: false }
          },
          y: {
            beginAtZero: true,
            ticks: { color: "#5C5E62", font: { size: 11 }, precision: 0 },
            grid: { color: "#EEEEEE" }
          }
        }
      }
    })
  })

  onDestroy(() => {
    chart?.destroy()
    chart = null
  })
</script>

<div class="relative" style="height: 240px;">
  {#if hasData}
    <canvas bind:this={canvas} aria-label="PII와 Secret 탐지 추이 차트"></canvas>
  {:else}
    <div class="flex h-full items-center justify-center gate-panel gate-muted">
      아직 표시할 위험 이벤트가 없습니다.
    </div>
  {/if}
</div>
